import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../employee.service';
import { Observable,Subject } from "rxjs";
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-removeinventory',
  templateUrl: './removeinventory.component.html',
  styleUrls: ['./removeinventory.component.css']
})
export class RemoveinventoryComponent implements OnInit {
  public nameForm:FormGroup;
  constructor(private employeeservice:EmployeeService,private formBuilder: FormBuilder) {
    this.nameForm = this.formBuilder.group({
      name: ''
    });
  }

  itemids: Observable<EmployeeService[]>;
  message = '';

  ngOnInit () {

  }

  
  removeInventoryItems() {
    console.log('name',this.nameForm.get('name').value);
    
    this.employeeservice.removeInventoryItems(this.nameForm.get('name').value)
      .subscribe(
        data => {
          console.log(data);
          this.message = 'Items Deleted Succesfuly!';
          this.refresh();
            }, err => {
              console.log(err);
              this.message = "Could not delete the item!"
              this.refresh();
            });
        }
        refresh(): void {
          window.location.reload();
      }
      
  }
